import { Partner } from './partner.model';
import { User } from './user.model';
import { Stay } from './stay.model';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '../modules/crud';

export enum InventoryStatus {
    Fixed = 'fixed',
    Issue = 'problem',
    Solved = 'solved'
}

export interface InventoryAttachment {
    fileName: string;
    filePath: string;
}

@CwtModel({ name: 'inventory', path: '/inventory' })
export class Inventory extends ApiData {
    user: User;
    stay: Stay;
    partner: Partner;
    content: string;
    attachment: InventoryAttachment[];
    status: InventoryStatus;
    creationDate: number;
}